import { REGISTER_SUCCESS } from './types';

const registrationReducer = (state, action) => {
    const { payload, type } = action;

    switch (type) {
        case REGISTER_SUCCESS:
            return {
                ...state,
                code: payload
            }
        default:
            return state
    }
}

export default registrationReducer;